var map = {
	"./add-green.svg": 93556,
	"./arrow-down-blue.svg": 71149,
	"./arrow-down.svg": 24746,
	"./arrow-left-navy.svg": 71811,
	"./arrow-right-blue.svg": 85823,
	"./arrow-up.svg": 29689,
	"./attachment-dark.svg": 23353,
	"./attachment-white.svg": 29621,
	"./betapprovals-emptystate.svg": 90705,
	"./blended-icon.svg": 46697,
	"./calendar-icon.svg": 91710,
	"./calendar.svg": 90874,
	"./checkmark.svg": 63538,
	"./close-white.svg": 78745,
	"./cross-red.svg": 57637,
	"./cross-remove-dark-circle.svg": 60732,
	"./default-profile-image.svg": 14995,
	"./delete-trash-red.svg": 66954,
	"./doc-preview-icon.svg": 33767,
	"./drop-down-button-icon.svg": 51673,
	"./fluc-down-arrow-red.svg": 66168,
	"./fluc-up-arrow-green.svg": 44252,
	"./generic-runner-shirt.svg": 32245,
	"./giftPack.svg": 82686,
	"./image-preview-icon.svg": 68688,
	"./mastercard.svg": 60174,
	"./multi-icon.svg": 67180,
	"./nav-bank.svg": 80517,
	"./nav-bet-approvals.svg": 36522,
	"./nav-dashboard.svg": 81593,
	"./nav-offerings.svg": 29778,
	"./nav-placed-bets.svg": 37715,
	"./nav-promo-manager.svg": 79906,
	"./nav-punters.svg": 77117,
	"./nav-settings.svg": 37140,
	"./nav-trade-manager.svg": 69406,
	"./paintbrush.svg": 76990,
	"./password-hide.svg": 56524,
	"./password-show.svg": 24688,
	"./player/amber.svg": 15910,
	"./player/blacklist.svg": 6035,
	"./player/fire.svg": 20137,
	"./player/highroller.svg": 77060,
	"./player/player.svg": 87998,
	"./player/plus.svg": 33508,
	"./player/recreational.svg": 1494,
	"./player/square.svg": 38513,
	"./player/triangle.svg": 83599,
	"./popup-confirm-delete.svg": 74132,
	"./search.svg": 79262,
	"./sgm-icon.svg": 99207,
	"./sports/afl-football.svg": 50214,
	"./sports/afl.svg": 1855,
	"./sports/american-football.svg": 99648,
	"./sports/australian-rules.svg": 68605,
	"./sports/badminton.svg": 99899,
	"./sports/baseball.svg": 70690,
	"./sports/basketball.svg": 60884,
	"./sports/box-challenge.svg": 26394,
	"./sports/boxing.svg": 62145,
	"./sports/cricket.svg": 96616,
	"./sports/cycling.svg": 53437,
	"./sports/darts.svg": 61196,
	"./sports/default.svg": 82163,
	"./sports/dog.svg": 43918,
	"./sports/field-hockey.svg": 73798,
	"./sports/golf.svg": 42593,
	"./sports/greyhounds.svg": 43924,
	"./sports/harness-racing.svg": 20446,
	"./sports/harness.svg": 77328,
	"./sports/horse-racing.svg": 62703,
	"./sports/horse.svg": 19719,
	"./sports/ice-hockey.svg": 19979,
	"./sports/jockey-challenge.svg": 32725,
	"./sports/money-back.svg": 35040,
	"./sports/motor-sport.svg": 28863,
	"./sports/politics.svg": 40873,
	"./sports/racing-extras.svg": 85695,
	"./sports/rugby-league.svg": 83488,
	"./sports/rugby-union.svg": 53882,
	"./sports/samegamemulti.svg": 59116,
	"./sports/snooker.svg": 52988,
	"./sports/soccer.svg": 59138,
	"./sports/sports-exotics.svg": 9122,
	"./sports/square-question.svg": 15799,
	"./sports/surfing.svg": 39259,
	"./sports/tennis.svg": 68659,
	"./sports/todays-offers.svg": 45957,
	"./sports/volleyball.svg": 45690,
	"./srm-icon.svg": 60360,
	"./stormlogo.svg": 52927,
	"./upload-dark.svg": 36606,
	"./visa.svg": 25593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;